export default __webpack_public_path__ + "static/media/D_Female.36499cdf.svg";